var render, staticRenderFns
import script from "./odoo-partner-create.vue?vue&type=script&lang=js&"
export * from "./odoo-partner-create.vue?vue&type=script&lang=js&"
import style0 from "./odoo-partner-create.vue?vue&type=style&index=0&id=215c98f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c98f9",
  null
  
)

export default component.exports